import { __decorate, __metadata } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ApiService, ConfigOauthService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

const SPE_N_ACCOUNT_CODE = '/spe-n-account-code/v1';
let SpeNAccountCodeProxy = class SpeNAccountCodeProxy {
    constructor(api) {
        this.api = api;
    }
    getCode(uuidWhiteLabel, uuidAccountPayment) {
        const uri = `${SPE_N_ACCOUNT_CODE}/generate/wl/${uuidWhiteLabel}/ap/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    checkCodeConsume(uuidWhiteLabel, uuidAccountPayment, code) {
        const uri = `${SPE_N_ACCOUNT_CODE}/consume/wl/${uuidWhiteLabel}/ap/${uuidAccountPayment}/code/${code}`;
        return this.api.get(uri);
    }
    checkCode(uuidWhiteLabel, uuidAccountPayment, code) {
        const uri = `${SPE_N_ACCOUNT_CODE}/wl/${uuidWhiteLabel}/ap/${uuidAccountPayment}/code/${code}`;
        return this.api.get(uri);
    }
    generateQrcodeCodeToken(uuidWhiteLabel, uuidAccountPayment, uuidOperation) {
        const uri = `${SPE_N_ACCOUNT_CODE}/qrcode/generate/wl/${uuidWhiteLabel}/ap/${uuidAccountPayment}/op/${uuidOperation}`;
        return this.api.get(uri);
    }
    readQrcode(qrcodeData, uuidAccountPayment) {
        const uri = `${SPE_N_ACCOUNT_CODE}/qrcode/read/${uuidAccountPayment}`;
        return this.api.post(uri, qrcodeData);
    }
    verifyQrcode(qrcodeData) {
        const uri = `${SPE_N_ACCOUNT_CODE}/qrcode/verify`;
        return this.api.post(uri, qrcodeData);
    }
};
SpeNAccountCodeProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNAccountCodeProxy);

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

let UiPxTokenModule = class UiPxTokenModule {
};
UiPxTokenModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            ConfigService, SpeNAccountCodeProxy
        ]
    })
], UiPxTokenModule);

export { ConfigService, SpeNAccountCodeProxy, UiPxTokenModule };
//# sourceMappingURL=wlp-ui-px-token.js.map
